//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'calendar',
  components: {},
  props: ['calendar', 'type', 'activeVal', 'tabType'],
  data: function data() {
    return {
      value: new Date(),
      dailyDay: {
        startTime: '',
        endTime: ''
      },
      clickDate: '',
      typeText: {
        0: '日报',
        1: '周报',
        3: '汇报'
      },
      data: {
        time: this.$moment(new Date()).format('YYYY-MM-DD'),
        type: []
      }
    };
  },
  computed: {},
  watch: {
    activeVal: {
      handler: function handler(nVal) {
        if (nVal == '4') {
          this.value = new Date(new Date().getTime() - 24 * 60 * 60 * 1000);
        } else {
          this.value = new Date();
        }
      },
      immediate: true,
      deep: true
    },
    tabType: {
      handler: function handler(nVal) {
        if (nVal == 0) {
          setTimeout(function () {
            var tdHover = document.querySelectorAll('.calendar_area');
            for (var i = 0; i < tdHover.length; i++) {
              tdHover[i].style.cursor = 'default';
            }
          }, 300);
        }
      },
      immediate: true,
      deep: true
    },
    clickDate: {
      handler: function handler(nVal, oVal) {
        if (this.activeVal == '4' && this.type == 1) {
          var row = document.querySelectorAll('.el-calendar-table__row');
          this.$nextTick(function () {
            var row1 = document.querySelector('.el-calendar-table td.is-selected');
            row1.style.background = '';
          });
          if (nVal == oVal) {
            row[nVal].style.backgroundColor = '#F2F8FE';
          } else {
            this.$nextTick(function () {
              for (var i = 0; i < row.length; i++) {
                row[nVal].style.backgroundColor = '#F2F8FE';
                if (oVal) {
                  row[oVal].style.backgroundColor = 'transparent';
                }
              }
            });
          }
        }
      },
      immediate: true,
      deep: true
    }
  },
  mounted: function mounted() {
    this.setCalendarButton();
    this.nextTPrevClick();
  },
  methods: {
    removeStyle: function removeStyle() {
      var row = document.querySelectorAll('.el-calendar-table__row');
      for (var i = 0; i < row.length; i++) {
        row[i].onclick = null;
        row[i].style.backgroundColor = 'transparent';
      }
    },
    // 选择周后，日历样式改变
    addIndex: function addIndex() {
      var list = document.querySelectorAll('.el-calendar-table__row');
      var row1 = document.querySelector('.el-calendar-table td.is-selected');
      row1.style.backgroundColor = '';
      for (var i = 0; i < list.length; i++) {
        list[i].index = i;
        list[i].onclick = function () {
          this.clickDate = this.index;
          for (var i = 0; i < list.length; i++) {
            list[i].style.backgroundColor = 'transparent';
          }
          list[this.index].style.backgroundColor = '#F2F8FE';
        };
      }
    },
    dateBnt: function dateBnt(data) {
      if (this.tabType == '0') {
        var row2 = document.querySelectorAll('.el-calendar-table td');
        for (var i = 0; i < row2.length; i++) {
          row2[i].style.backgroundColor = 'transparent';
        }
      }
      this.data.time = data;
      this.$emit('currentTime', data);
    },
    // 根据某天获取这一周
    getMonthWeek: function getMonthWeek(theDate) {
      var currentDay = new Date(theDate);
      var theSaturday = currentDay.getDate() + (6 - currentDay.getDay());
      return Math.ceil(theSaturday / 7);
    },
    // 选择周后样式修改
    setWeek: function setWeek() {
      var numWeek = this.getMonthWeek(this.$moment()) - 1;
      // this.value = new Date(new Date().getTime() - 24 * 60 * 60 * 1000);
      this.value = new Date();
      this.clickDate = numWeek;
    },
    setCalendarButton: function setCalendarButton() {
      var _this = this;
      this.$nextTick(function () {
        var prevBtn = document.querySelector('.el-button-group button:nth-of-type(1)');
        var nextBtn = document.querySelector('.el-button-group button:nth-of-type(3)');
        _this.dailyDay.startTime = document.querySelector('.dealt-date .el-calendar-table__row:first-child td:nth-child(1) input').value;
        _this.dailyDay.endTime = document.querySelector('.dealt-date .el-calendar-table__row:last-child td:last-child input').value;
        prevBtn.className = 'el-button--text';
        prevBtn.lastChild.setAttribute('class', 'el-icon-arrow-left');
        prevBtn.lastChild.innerHTML = '';
        nextBtn.setAttribute('class', 'el-button--text');
        nextBtn.lastChild.setAttribute('class', 'el-icon-arrow-right');
        nextBtn.lastChild.innerHTML = '';
        _this.$emit('switchTime', _this.dailyDay);
      });
    },
    nextTPrevClick: function nextTPrevClick() {
      var _this2 = this;
      this.$nextTick(function () {
        var prevBtn = document.querySelector('.dealt-date .el-calendar__button-group .el-button-group>button:nth-child(1)');
        var nextBtn = document.querySelector('.dealt-date .el-calendar__button-group .el-button-group>button:nth-child(3)');
        var prevFirst = document.querySelector('.dealt-date .el-calendar-table__row:first-child');
        var nextLast = document.querySelector('.dealt-date .el-calendar-table__row:last-child');
        var prevArr = prevFirst.getElementsByClassName('prev');
        var nextArr = nextLast.getElementsByClassName('next');
        for (var i = 0; i < prevArr.length; i++) {
          _this2.tabClick(prevArr[i]);
        }
        for (var _i = 0; _i < nextArr.length; _i++) {
          _this2.tabClick(nextArr[_i]);
        }
        _this2.tabClick(prevBtn);
        _this2.tabClick(nextBtn);
      }, 500);
    },
    getCalendarDay: function getCalendarDay(day) {
      var len = this.calendar.length;
      var str = false;
      if (len > 0) {
        for (var i = 0; i < len; i++) {
          if (this.calendar[i].time === day) {
            if (this.calendar[i].no_submit == 1) {
              str = true;
            } else {
              str = false;
            }
            break;
          }
        }
      }
      return str;
    },
    tabClick: function tabClick(obj) {
      var _this3 = this;
      obj.addEventListener('click', function (e) {
        _this3.dailyDay.startTime = document.querySelector('.dealt-date .el-calendar-table__row:first-child td:nth-child(1) input').value;
        _this3.dailyDay.endTime = document.querySelector('.dealt-date .el-calendar-table__row:last-child td:last-child input').value;
        _this3.$emit('switchTime', _this3.dailyDay);
      });
    }
  }
};